import { useTranslation } from 'next-i18next'

import ROUTES from '~/shared/constants/routes.const'
import { ExternalLink } from '~/components/ExternalLink'
import { Button } from '~/components'
import Quote from '~/assets/quote'
import HoMCard from '~/components/HoMCard'

export function Lectures(): React.ReactElement {
  const { t } = useTranslation('lectures')

  return (
    <div className="max-w-4xl mx-auto mt-12 px-4 lg:pb-16">
      <h1 className="w-full sm:w-2/3 2xl:w-2/5 mx-auto mb-16 rounded bg-purple text-center font-semibold text-h3 xl:text-h2 text-white">
        {t('title')}
      </h1>
      <section className="space-y-8">
        <div className="relative bg-white rounded xl:rounded shadow-experimental">
          <Header text={t('introHeader')} />
          <p className="px-6 pt-12 xl:p-16 xl:pb-8 whitespace-pre-line text-about xl:text-about-large text-gray-sub-text">
            {t('introText')}
          </p>
          <ul className="p-6 xl:px-16 list-disc space-y-2 text-about xl:text-about-large">
            <div className="pb-4">{t('motivationHeader')}</div>
            <li className="list-item ml-8 text-gray-sub-text">{t('motivationListItem1')}</li>
            <li className="list-item ml-8 text-gray-sub-text">{t('motivationListItem2')}</li>
            <li className="list-item ml-8 text-gray-sub-text">{t('motivationListItem3')}</li>
          </ul>
          <ul className="p-6 xl:px-16 list-disc space-y-2 text-about xl:text-about-large">
            <div className="pb-4">{t('entrepreneurshipHeader')}</div>
            <li className="list-item ml-8 text-gray-sub-text">{t('entrepreneurshipItem1')}</li>
            <li className="list-item ml-8 text-gray-sub-text">{t('entrepreneurshipItem2')}</li>
          </ul>

          <p className="p-6 pb-16 sm:p-8 sm:pt-6 xl:p-16 xl:pt-8 whitespace-pre-line text-about xl:text-about-large text-gray-sub-text">
            {t('outroText')} <ExternalLink href="mailto:support@houseofmath.com.">support@houseofmath.com</ExternalLink>
            .
          </p>
        </div>

        <div className="flex flex-col lg:flex-row space-x-0 lg:space-x-8 space-y-8 lg:space-y-0">
          <div className="flex flex-col md:flex-row lg:flex-col space-y-8 md:space-y-0 md:space-x-8 lg:space-y-8 lg:space-x-0">
            <QuoteSection />
            <div className="hidden lg:block">
              <CallToAction />
            </div>
            <div className="w-full h-full flex justify-center lg:hidden">
              <HoMCard
                bio={t('vibekeBio')}
                education={t('vibekeEducation')}
                imageSrcKey="team/vibeke-fangsrud.png"
                name={t('vibekeName')}
                title={t('vibekeTitle')}
              />
            </div>
          </div>
          <div className="hidden lg:block">
            <HoMCard
              bio={t('vibekeBio')}
              education={t('vibekeEducation')}
              imageSrcKey="team/vibeke-fangsrud.png"
              name={t('vibekeName')}
              title={t('vibekeTitle')}
            />
          </div>
          <div className="w-full h-full lg:hidden">
            <CallToAction />
          </div>
        </div>
      </section>
    </div>
  )
}

function Header({ text }: { text: string }): React.ReactElement {
  return (
    <header
      className={
        'w-11/12 md:w-max absolute transform -translate-y-1/2 ' +
        'left-1/2 -translate-x-1/2 ' +
        'px-4 py-1 sm:px-6 sm:py-2 xl:px-12 xl:py-4 ' +
        'inline-block rounded xl:rounded ' +
        `bg-purple text-center font-medium xl:font-semibold text-menu xl:text-lg text-white`
      }
    >
      {text}
    </header>
  )
}

function QuoteSection(): React.ReactElement {
  const { t } = useTranslation('lectures')

  return (
    <div className="md:w-full h-min relative p-12 bg-white rounded xl:rounded shadow-experimental">
      <img alt="quote" src={Quote} />
      <p className="py-8 leading-loose text-gray-light-fade">{t('quoteText')}</p>
      <h3 className="text-lg font-medium text-black-card">{t('quoteName')}</h3>
      <h4 className="font-medium text-purple">{t('quoteRole')}</h4>
    </div>
  )
}

function CallToAction(): React.ReactElement {
  const { t } = useTranslation('lectures')

  return (
    <div className="relative p-12 flex flex-col items-center bg-white rounded xl:rounded shadow-experimental text-center md:text-left">
      <div>
        <h3 className="text-lg font-medium text-black-card">{t('media')}</h3>
        <p className="py-4 md:py-0 leading-loose text-gray-light-fade">{t('learnMore')}</p>
      </div>

      <Button className="mx-2 md:mx-8 text-xs whitespace-nowrap" to={ROUTES.MEDIA_NEWS}>
        {t('mediaButton')}
      </Button>
    </div>
  )
}
